/* eslint-disable @typescript-eslint/no-explicit-any */
import { Alert } from '@mui/material';
import React from 'react';
/**
 * This is rendered if widget is not found for a widget config type.
 */
export const unknownWidget = {
    type: '-',
    component: (props) => {
        var _a;
        return React.createElement(Alert, { color: 'error' },
            "Unknown widget type: ", (_a = props.config.type) !== null && _a !== void 0 ? _a : 'undefined');
    },
};
/**
 * Recursively walk the widget tree.
 * @param props - starting point
 * @param callback - function to call for each widget props in the tree including the starting point
 * @see Widget.renderOnAnyError
 * @see WidgetProps.rootWidgetProps
 */
export function walkWidgetPropsTree(props, callback) {
    callback(props);
    if (props.childProps) {
        props.childProps.forEach((childProps) => walkWidgetPropsTree(childProps, callback));
    }
    if (props.childDynamicRows) {
        props.childDynamicRows.forEach((row) => row.childProps.forEach((childProps) => walkWidgetPropsTree(childProps, callback)));
    }
}
